import { useQuery } from "@tanstack/react-query";
import { DocumentApiV2 } from "../../../services/document/document-v2.service";
import { DocumentService } from "../../../services/document/document.service";

const mapRecentDistributionDocument = (driveItem: any[]) => {
  return driveItem.map((e: any) => ({
    ...DocumentService.mapData(e),
    creator: e.createdBy?.user.displayName
  })).reverse().slice(0, 10);
};

export const useRecentDistributionDocument = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["recent-distribution-document"],
    queryFn: () => DocumentApiV2.getRecentPublishDoc(),
    select: (res: any) => mapRecentDistributionDocument(res),
  });

  return { data, isLoading };
};
